import { Specification } from '@dgx-pr-spa/shared/util';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyFeatures',
})
export class KeyFeaturesPipe implements PipeTransform {
  transform(array: Specification[]): Specification[] {
    const keyFeatures = array.slice(0, 3);

    const titles = ['COLOUR', 'ENERGY EFFICIENCY', 'MEASUREMENTS'];

    return keyFeatures.filter(
      (feature) => titles.includes(feature.name.toUpperCase()) && feature.value
    );
  }
}
